import { pageTitleSx } from "../../constants/designTokens";
import React from "react";
import Grid from "@mui/material/GridLegacy";
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormLabel from '@mui/material/FormLabel';
import {Controller, useForm} from "react-hook-form";
import {IStatement} from "../../queries/pharmacy/pharmacyModel";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";

interface ReviewFollowingStatementsProps {
  data: any;
}

const ReviewFollowingStatements:React.FunctionComponent<ReviewFollowingStatementsProps> = ({
  data,
}) => {
  const filteredStatements = data.map((statement: IStatement) => {
    return {
      id: statement.id,
      question: statement.Statement.question,
      answer: statement.answer ? 'YES' : 'NO',
      statementId: statement.statementId,
    }
  });

  const { control } = useForm();

  return (
    <Box>
      <Typography component="h1" sx={{ ...pageTitleSx, mb: 3 }}>Review Following Statements</Typography>
      <Grid container spacing={2}>
        {[...filteredStatements].sort((a, b) => a.id - b.id).map((statement: any)=> (
          <React.Fragment key={statement.id}>
            <Grid item xs={12} sm={6} md={9}>
              <FormLabel id={`statement-${statement.statementId}-${statement.id}-label`} sx={{color: '#222222'}} >
                <div dangerouslySetInnerHTML={{ __html: statement?.question }}></div>
              </FormLabel>
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <Controller
                name={`statement-${statement.statementId}-${statement.id}`}
                control={control}
                defaultValue={statement.answer}
                render={({ field }) => (
                  <RadioGroup
                    {...field}
                    row
                    aria-labelledby={`statement-${statement.statementId}-${statement.id}-label`}
                    id={`statement-${statement.statementId}-${statement.id}`}
                    onChange={() => false}
                  >
                    <FormControlLabel value="YES" control={<Radio />} label="Yes" />
                    <FormControlLabel value="NO" control={<Radio />} label="No" />
                  </RadioGroup>
                )}
              />
            </Grid>
          </React.Fragment>
        ))}
      </Grid>
    </Box>
  )
}

export default ReviewFollowingStatements;